import React, { useState } from 'react';

// Accept the new setModalConfig prop
export default function ViewStudents({ students, enrollments, batches, setActiveTab, setSelectedBatchId, setModalConfig }) {
  const [search, setSearch] = useState('');

  const filtered = students.filter(s =>
    (s.name.toLowerCase().includes(search.toLowerCase()) || s.regId.toLowerCase().includes(search.toLowerCase()) || s.mobile.includes(search.toLowerCase())) 
  );

  const getCategory = (dob) => {
    const birthDate = new Date(dob);
    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();

    if (
      monthDiff < 0 ||
      (monthDiff === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age >= 18 ? 'ADULT' : 'CHILD';
  };

  return (
    <div className="admin-card">
      <h2>Registered Students</h2>

      <div className="filter-toolbar">
        <input type="text" className="filter-input" placeholder="Search Name/ID/Mobile..." onChange={e => setSearch(e.target.value)} />
      </div>

      <div className="table-responsive">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Student Name</th>
              <th>Type</th>
              <th>Contact</th>
              <th>Program & Batch</th>
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 ? (
              <tr><td colSpan="5" style={{ textAlign: 'center' }}>No students found.</td></tr>
            ) : (
              filtered.map(s => {
                const studentEnrollments = enrollments.filter(e => e.studentId === s.id);

                return (
                  <tr key={s.id}>
                    <td style={{ color: 'var(--accent-gold)', fontWeight: 'bold' }}>{s.regId}</td>
                    <td>
                      {/* UPDATED: CLICKABLE STUDENT NAME */}
                      <span
                        style={{ color: 'var(--accent-blue)', cursor: 'pointer', fontWeight: 'bold', fontSize: '1.05rem', transition: 'color 0.2s' }}
                        onClick={() => setModalConfig({ isOpen: true, type: 'student-info', studentId: s.id })}
                        onMouseEnter={(event) => event.target.style.textDecoration = 'underline'}
                        onMouseLeave={(event) => event.target.style.textDecoration = 'none'}
                      >
                        {s.name}
                      </span>
                    </td>
                    <td><span className="badge">{getCategory(s.dob)}</span></td>
                    <td>{s.mobile}<br /><small style={{ color: '#64748b' }}>{s.email}</small></td>
                    <td>
                      {studentEnrollments.length === 0 ? (
                        <span style={{ color: '#64748b', fontStyle: 'italic' }}>Not Enrolled</span>
                      ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                          {studentEnrollments.map(enroll => {
                            const batch = batches.find(b => b.id === enroll.batchId);
                            if (!batch) return null;
                            return (
                              <div key={enroll.id} style={{ fontSize: '0.85rem' }}>
                                <span className="badge" style={{ padding: '2px 6px', fontSize: '0.7rem', marginRight: '6px' }}>
                                  {batch.type}
                                </span>
                                {/* CLICKABLE BATCH LINK */}
                                <span
                                  style={{ color: 'var(--accent-blue)', cursor: 'pointer', fontWeight: 'bold', transition: 'color 0.2s' }}
                                  onClick={() => {
                                    setSelectedBatchId(batch.id);
                                    setActiveTab('batch-details');
                                  }}
                                  onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                                  onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                                >
                                  {batch.title}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}